module.exports = __webpack_public_path__ + "img/file-pdf.ba2254bb.svg";